import { z } from 'zod';
import { sequenceBranchRuleSchema } from '../sequences/branchRules.js';
export const CAMPAIGN_TYPES = ['cold_outreach', 'partnership', 'backlink', 'broadcast'];
export const CAMPAIGN_TYPE_LABELS = {
    cold_outreach: 'Cold outreach',
    partnership: 'Partnership',
    backlink: 'Backlink',
    broadcast: 'One-shot broadcast',
};
export const CAMPAIGN_STATUSES = ['draft', 'scheduled', 'running', 'paused', 'completed'];
/** FO B-02 / deliverability — max parallel running campagnes per project. */
export const MAX_RUNNING_CAMPAIGNS_PER_PROJECT = 3;
export const listCreateSchema = z.object({
    project_id: z.string().uuid(),
    name: z.string().min(1).max(200),
});
export const listMembersSchema = z.object({
    lead_ids: z.array(z.string().uuid()).min(1).max(5000),
});
export const sequenceStepSchema = z
    .object({
    step_order: z.number().int().min(0),
    wait_days: z.number().int().min(0).max(365),
    subject_template: z.string().max(998).default(''),
    body_text_template: z.string().max(100_000).default(''),
    email_template_id: z.string().uuid().nullable().optional(),
    branch_rules: z.array(sequenceBranchRuleSchema).max(10).optional(),
    step_channel: z.enum(['email', 'voice']).optional(),
})
    .superRefine((step, ctx) => {
    if (step.step_channel === 'voice')
        return;
    if (step.email_template_id)
        return;
    if (!step.subject_template.trim()) {
        ctx.addIssue({
            code: 'custom',
            message: 'subject_template required without email_template_id',
            path: ['subject_template'],
        });
    }
    if (!step.body_text_template.trim()) {
        ctx.addIssue({
            code: 'custom',
            message: 'body_text_template required without email_template_id',
            path: ['body_text_template'],
        });
    }
});
export const sequenceCreateSchema = z.object({
    project_id: z.string().uuid(),
    name: z.string().min(1).max(200),
    steps: z.array(sequenceStepSchema).min(1).max(20),
});
export const campaignCreateSchema = z
    .object({
    project_id: z.string().uuid(),
    name: z.string().min(1).max(200),
    type: z.enum(CAMPAIGN_TYPES).default('cold_outreach'),
    list_id: z.string().uuid().optional(),
    audience_id: z.string().uuid().optional(),
    sequence_id: z.string().uuid(),
})
    .refine((d) => Boolean(d.list_id ?? d.audience_id), {
    message: 'list_id of audience_id is verplicht',
});
export const CAMPAIGN_QUICK_DELIVERY = ['brevo_broadcast', 'sequence'];
export const CAMPAIGN_QUICK_DELIVERY_LABELS = {
    brevo_broadcast: 'Direct via Brevo (newsletter/broadcast)',
    sequence: 'Outreach-sequence (SMTP of Brevo transactional)',
};
export const campaignQuickSendSchema = z
    .object({
    project_id: z.string().uuid(),
    email_template_id: z.string().uuid(),
    list_id: z.string().uuid().optional(),
    audience_id: z.string().uuid().optional(),
    name: z.string().min(1).max(200).optional(),
    delivery: z.enum(CAMPAIGN_QUICK_DELIVERY),
    send_rail: z.enum(['smtp', 'brevo_transactional']).optional(),
})
    .refine((d) => Boolean(d.list_id ?? d.audience_id), {
    message: 'list_id of audience_id is verplicht',
});
export const suppressionCreateSchema = z.object({
    project_id: z.string().uuid().optional().nullable(),
    email: z.string().email().optional().nullable(),
    domain: z.string().min(1).max(253).optional().nullable(),
    reason: z.enum(['unsubscribe', 'bounce_hard', 'manual', 'complaint']).default('manual'),
});
//# sourceMappingURL=campaign.js.map